import Team from './Team.jsx';

export default Team;
